import React from "react";
import {
  formatAppointmentCellValue,
  getClosingStatusBadgeClass,
  getCheckInStatusBadgeClass,
} from "utils/appointmentListStatusDisplay";
import { getStatusBadgeIconClass } from "utils/statusBadgeIcons";
import "../../screens/Visitor/VisitorListing.css";

/** Icon language aligned with booking + distinct mid-funnel states. */
export const StatusBadgeIcon = ({ badgeClass = "", iconClass }) => (
  <span className="visitor-status-badge__icon" aria-hidden="true">
    <i className={iconClass || getStatusBadgeIconClass(badgeClass)} />
  </span>
);

const StatusBadge = ({ label, badgeClass, size }) => {
  const text = formatAppointmentCellValue(label);
  if (text === "-") {
    return <span className="visitor-listing__empty">-</span>;
  }

  const tone = badgeClass || getClosingStatusBadgeClass(text);
  const sizeClass = size === "sm" ? " visitor-status-badge--sm" : "";

  return (
    <span className={`visitor-status-badge ${tone}${sizeClass}`} title={text}>
      <StatusBadgeIcon badgeClass={tone} />
      <span className="visitor-status-badge__label">{text}</span>
    </span>
  );
};

export const CheckInStatusBadge = ({ showAsVisited, label }) => (
  <StatusBadge
    label={label != null ? label : showAsVisited ? "Checked In" : ""}
    badgeClass={getCheckInStatusBadgeClass(showAsVisited)}
    size="sm"
  />
);

export default StatusBadge;
